import React, { useEffect, useState } from 'react';
import { portalApi, formatApiError } from '../../services/api';
import { Receipt, DownloadSimple } from '@phosphor-icons/react';
import { toast } from 'sonner';

const fmtEUR = (v) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(v || 0));

export default function PortalInvoices() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await portalApi.invoices();
        setItems(r.data || []);
      } catch (err) { toast.error(formatApiError(err)); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="p-6 space-y-6" data-testid="portal-invoices-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-[#111418]">Rechnungen</h1>
        <p className="text-[#525866] mt-1">Alle Rechnungen Ihres Kontos</p>
      </div>

      {loading ? (
        <div className="card-swiss h-24 skeleton" />
      ) : items.length === 0 ? (
        <div className="card-swiss p-12 text-center">
          <Receipt weight="thin" size={64} className="mx-auto text-[#8A94A6] mb-4" />
          <p className="text-[#525866]">Noch keine Rechnungen vorhanden.</p>
        </div>
      ) : (
        <div className="card-swiss overflow-hidden">
          <table className="table-swiss">
            <thead><tr><th>Rechnung</th><th>Datum</th><th>Fällig</th><th className="text-right">Betrag</th><th className="text-right">Bezahlt</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {items.map((inv) => (
                <tr key={inv.id} data-testid={`portal-invoice-row-${inv.id}`}>
                  <td className="font-semibold">{inv.invoice_number}</td>
                  <td className="text-sm text-[#525866]">{(inv.created_at || '').slice(0, 10)}</td>
                  <td className="text-sm text-[#525866]">{inv.due_date}</td>
                  <td className="text-right font-semibold">{fmtEUR(inv.total)}</td>
                  <td className="text-right text-sm">{fmtEUR(inv.paid_amount)}</td>
                  <td>
                    <span className={`text-xs px-2 py-1 rounded font-semibold ${
                      inv.status === 'paid' ? 'bg-emerald-100 text-emerald-700' :
                      inv.status === 'overdue' ? 'bg-red-100 text-red-700' :
                      'bg-amber-100 text-amber-700'
                    }`}>{inv.status}</span>
                  </td>
                  <td>
                    <a href={portalApi.invoicePdfUrl(inv.id)} target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline text-sm inline-flex items-center gap-1" data-testid={`portal-invoice-pdf-${inv.id}`}>
                      <DownloadSimple weight="bold" size={14} /> PDF
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
